/**

 * Shared toolbar class tokens — visual parity with PipelineToolbar.

 * Used by ToolbarIconDropdown, ListSearchInput, ListSearchFilterBar.

 * Design-system primary / neutral only (no slate drift).

 */



export const toolbarSegmentGroup =

  'h-9 inline-flex items-center gap-1 p-0.5 rounded-lg border border-primary-500/15 bg-primary-50/80';



export const toolbarSegmentButton =

  'h-8 px-3 rounded-md text-sm font-medium flex items-center justify-center gap-1.5 transition-all duration-200';



export const toolbarSegmentActive = 'bg-primary-500 text-white shadow-sm';



export const toolbarSegmentInactive = 'text-neutral-600 hover:text-primary-600 hover:bg-white';



export const toolbarStandaloneBase =

  'h-9 px-2.5 rounded-lg text-sm font-medium flex items-center justify-center gap-1 border transition-all duration-200 shadow-sm';



export const toolbarStandaloneInactive =

  'border-primary-500/15 bg-white text-neutral-600 hover:border-primary-500/35 hover:text-primary-600';



export const toolbarStandaloneActive =

  'border-primary-500 bg-primary-500 text-white hover:border-primary-600 hover:bg-primary-600 hover:text-white';



export const toolbarMenuItem = 'w-full text-left px-3 py-2 text-sm transition-colors';



export const toolbarMenuItemActive = 'bg-primary-50/70 text-primary-500 font-semibold';



export const toolbarMenuItemInactive = 'text-neutral-800 hover:bg-neutral-50 font-medium';



export const toolbarMenuItemDanger = 'text-error-600 hover:bg-error-50 font-medium';



export const toolbarDropdownPanel =

  'absolute top-full mt-1 min-w-[12rem] w-max max-w-[min(20rem,calc(100vw-2rem))] bg-white text-neutral-800 rounded-lg border border-primary-500/15 shadow-xl z-50 py-1.5 overflow-y-auto origin-top-left animate-in fade-in slide-in-from-top-2 duration-200';



/** Chrome for menus portaled to document.body (fixed coords + high z-index set inline). */

export const toolbarDropdownPanelPortaled =

  'min-w-[12rem] w-max max-w-[min(20rem,calc(100vw-2rem))] bg-white text-neutral-800 rounded-lg border border-primary-500/15 shadow-xl py-1.5 overflow-y-auto origin-top-left animate-in fade-in slide-in-from-top-2 duration-200';



export const toolbarMenuItemLabel = 'block whitespace-nowrap';



export const toolbarActionButton =

  'h-9 px-2.5 rounded-lg text-sm font-medium inline-flex items-center justify-center gap-1.5 border transition-all duration-200 shadow-sm border-primary-500/15 bg-white text-neutral-600 hover:border-primary-500/35 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-50';



export const toolbarActionButtonDanger =

  'h-9 px-2.5 rounded-lg text-sm font-medium inline-flex items-center justify-center gap-1.5 border transition-all duration-200 shadow-sm border-error-500/30 bg-white text-error-600 hover:bg-error-50 disabled:cursor-not-allowed disabled:opacity-50';



export const toolbarBusyPill =

  'inline-flex h-9 items-center gap-1.5 rounded-lg border border-primary-500/15 bg-primary-500/10 px-2.5 text-xs font-medium text-primary-700';



export const toolbarSearchInput =

  'w-full sm:min-w-[240px] h-9 pl-9 pr-3 rounded-lg text-neutral-700 font-medium text-sm border border-primary-500/15 shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500/40 placeholder:text-neutral-400';



export const dropdownTriggerIconClass = (active: boolean) =>

  `w-4 h-4 shrink-0 ${active ? 'text-white/90' : 'text-neutral-500'}`;

/** Compact Filters panel under the toolbar toggle (phones). */
export const toolbarFiltersPanel =
  'mt-2 w-full rounded-xl border border-primary-500/15 bg-white p-3 shadow-xl';


